<template>
  <div>
    <b-card>
      <!--begin::Signin-->
      <div class="login-form login-signin">
        <div class="text-center mb-10 mb-lg-20">
          <h3 class="font-size-h1">بازیابی رمز عبور</h3>
          <p class="text-muted font-weight-semi-bold">
            اطلاعات زیر را وارد نمایید
          </p>
        </div>

        <!--begin::Form-->
        <b-form class="form" @submit.stop.prevent="onSubmit">
          <div
            role="alert"
            v-bind:class="{ show: errors.length }"
            class="alert fade alert-danger"
          >
            <div class="alert-text" v-for="(error, i) in errors" :key="i">
              {{ error }}
            </div>
          </div>
          <b-alert :show="success" variant="success">
            رمز عبور شما با موفقیت تغییر یافت</b-alert
          >
          <b-form-group label="کد پیامکی" label-for="code">
            <b-form-input
              id="code"
              type="text"
              v-model="$v.form.code.$model"
              :state="validateState('code')"
              placeholder="کد پیامکی را وارد کنید"
            ></b-form-input>
            <b-form-invalid-feedback id="input-2-live-feedback"
              >کد پیامکی اجباری است</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group label="رمز عبور جدید" label-for="pass">
            <b-form-input
              id="pass"
              type="password"
              v-model="$v.form.new.$model"
              :state="validateState('new')"
              placeholder="رمز عبور جدید وارد کنید"
            ></b-form-input>
            <b-form-invalid-feedback id="input-2-live-feedback"
              >رمز عبور جدید اجباری است</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group label="تکرار رمز عبور جدید" label-for="RePass">
            <b-form-input
              id="RePass"
              type="password"
              v-model="$v.form.reNew.$model"
              :state="validateState('reNew')"
              placeholder="تکرار رمز عبور جدید وارد کنید"
            ></b-form-input>
            <b-form-invalid-feedback id="input-2-live-feedback"
              >تکرار رمز عبور اجباری است</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group label="کد تایید">
            <b-row>
              <b-col cols="5">
                <b-form-input
                  v-model="$v.form.captcha.$model"
                  :state="validateState('captcha')"
                  placeholder="کد تایید"
                ></b-form-input>
                <b-form-invalid-feedback id="input-2-live-feedback"
                  >کد تایید اجباری است</b-form-invalid-feedback
                >
              </b-col>
              <b-col cols="5">
                <b-img
                  center
                  fluid
                  :src="captcha_img"
                  style="height: 38px"
                ></b-img>
              </b-col>
              <b-col>
                <b-button variant="warning" @click="resetCaptcha"
                  ><b-icon icon="arrow-clockwise"></b-icon
                ></b-button>
              </b-col>
            </b-row>
          </b-form-group>

          <!--begin::Action-->
          <div
            class="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <button
              ref="kt_login_signin_submit"
              class="btn btn-success btn-block font-weight-bold px-9 py-4 my-3 font-size-3"
            >
              تغییر رمز عبور
            </button>
          </div>
          <!--end::Action-->
          <!--begin::Action-->
          <div
            class="form-group d-flex flex-wrap justify-content-between align-items-center"
          >
            <router-link
              class="font-weight-bold font-size-3 ml-2"
              :to="{ name: 'login' }"
              >ورود</router-link
            >

            <router-link
              class="font-weight-bold font-size-3 ml-2"
              :to="{ name: 'register' }"
              >ثبت نام</router-link
            >
          </div>
          <!--end::Action-->
        </b-form>
        <!--end::Form-->
      </div>
      <!--end::Signin-->
    </b-card>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
</style>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

import { validationMixin } from "vuelidate";
import { email, minLength, required } from "vuelidate/lib/validators";
import httpHelper from "../../helpers/httpHelper";
import sessionHelper from "../../helpers/sessionHelper";
const numbers = (value, vm) => !/[^0-9]/.test(value);

export default {
  mixins: [validationMixin],
  name: "forget_step_2",
  components: {
    "vue-recaptcha": VueRecaptcha,
  },
  data() {
    return {
      // Remove this dummy login info
      form: {
        code: "",
        new: "",
        reNew: "",
        captcha: "",
      },
      captcha_img: "",
      success: false,
      errors: [],
    };
  },
  validations: {
    form: {
      captcha: {
        required,
      },
      code: {
        required,
        minLength: minLength(3),
        numbers,
      },
      new: {
        required,
        minLength: minLength(6),
      },
      reNew: {
        required,
        minLength: minLength(6),
      },
    },
  },
  methods: {
    resetCaptcha() {
      console.log("ResetCaptcha");
      httpHelper.getData("cp").then((res) => {
        console.log(res);
        this.captcha_img = res.result.img;
        this.form.captcha = "";
        this.form.key = res.result.key;
      });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onVerify: function(response) {
      if (response) {
        this.form.robot = true;
        this.form.captcha = response;
      }
    },
    resetForm() {
      this.form = {
        code: null,
        new: null,
        reNew: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        console.log(this.$v.form.$anyError);
        return;
      }

      this.errors = [];
      if (this.$v.form.new.$model != this.$v.form.reNew.$model) {
        this.errors.push("رمز عبور و تکرار آن مطابفت ندارد");
        return;
      }
      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      var data = {
        code: this.$v.form.code.$model,
        new: this.$v.form.new.$model,
        reNew: this.$v.form.reNew.$model,
        captcha: this.$v.form.captcha.$model,
        key: this.form.key,
      };
      httpHelper
        .postData("users/resetpass_2_step", data)
        .then((res) => {
          this.resetCaptcha();
          if (res.success == false) {
            this.errors = [res.error];
          } else {
            this.success = true;
            //sessionHelper.setUser(res.result);
            //this.$router.push({ name: "dashboard" });
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
  },
  computed: {},
  mounted() {
    this.resetCaptcha();
  },
};
</script>
